// this is the name of the placeholder image that comes from feed
const playerImagePlaceholder = '/0.png';
export const isPlayerImgPlaceholder = (playerImageUrl?: string): boolean => {
    return !playerImageUrl || playerImageUrl.includes(playerImagePlaceholder);
};
